import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["option"]

  connect() {
    // Enable/disable continue button based on initial selection
    this.updateContinueButton()
  }

  handleSelection(event) {
    // Update continue button when selection changes
    this.updateContinueButton()
  }

  updateContinueButton() {
    const radioButtons = document.querySelectorAll('input[name="selected_industry"]')
    const continueBtn = document.getElementById('continue-btn')
    
    const isSelected = Array.from(radioButtons).some(radio => radio.checked)
    
    if (continueBtn) {
      continueBtn.disabled = !isSelected
    }
  }
}
